import { getItemsIds } from '../../../../../utils/common'
import {
  toFlatSelectItems,
  toFlatWithBuildingSelectItem,
} from '../../../../Flat'

export function getFlatApiParams({ building, flats }) {
  return {
    ...(flats?.length > 0 ? { exclude_id: getItemsIds(flats, 'value') } : null),
    building,
  }
}

export function toFlatWithBuildingSelectItems(items) {
  return toFlatSelectItems(items, toFlatWithBuildingSelectItem)
}
